import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "17 21 17 13 7 13 7 21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "7 3 7 8 15 8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Save";
const Save = memo(themed(Icon));
export {
  Save
};
//# sourceMappingURL=save.js.map
